<h1 mat-dialog-title>{{action}}
  <ng-container i18n="Competitions Details Modal|Competitions Details modal title@@competitions-details-modal-title">
    Competition
  </ng-container>
</h1>
<div mat-dialog-content #dialogContent class="full-width details-content">
  <permission-checker [roles]="roles" (contentInit)="initContent()">
    <form [formGroup]="detailsForm" (ngSubmit)="proceed()">
      <form-input [control]="nameField"
                  label="Name"
                  i18n-label="Competitions Details Modal|Competitions Details modal name input label@@competitions-details-modal-name-input-label"
                  placeholder="Competition name..."
                  i18n-placeholder="Competitions Details Modal|Competitions Details modal name input placeholder@@competitions-details-modal-name-input-placeholder"
                  [minLength]="3" [maxLength]="128"></form-input>
      <form-input [control]="domainField"
                  label="Domain Prefix"
                  i18n-label="Competitions Details Modal|Competitions Details modal domain prefix input label@@competitions-details-modal-domain-prefix-input-label"
                  placeholder="Domain Prefix..."
                  i18n-placeholder="Competitions Details Modal|Competitions Details modal domain prefix input placeholder@@competitions-details-modal-domain-prefix-input-placeholder"
                  [minLength]="3" [maxLength]="16"></form-input>

      <mat-slide-toggle [formControl]="publishedField" color="primary"
                        i18n="Competitions Details Modal|Competitions Details modal published slider label@@competitions-details-modal-published-slider-label">Published</mat-slide-toggle>

      <div *ngIf="competitionId" class="editor">
        <mat-label
          i18n="Competitions Details Modal|Competitions Details modal description input label@@competitions-details-modal-description-input-label">
          Description
        </mat-label>
        <editor *ngIf="initEditor"
                [formControl]="descriptionField"
                [apiKey]="editorApiKey"
                [init]="editorConfig"
                [disabled]="descriptionField.disabled"></editor>
        <mat-error *ngIf="descriptionField.hasError('maxlength') && descriptionField.dirty"
                   class="mat-small">
          <ng-container
            i18n="Form Validation|Invalid competition description max length@@form-validation-input-invalid-competition-description-max">
            Description HTML code should contain less than 5120 characters
          </ng-container>
        </mat-error>
      </div>
    </form>
  </permission-checker>
</div>
<div mat-dialog-actions>
  <app-button [disabled]="inProgress"
              (clicked)="closeModal()"
              [secondary]="true"
              label="Cancel"
              i18n-label="General|Cancel action label@@general-cancel-action-label"></app-button>
  <span class="btn-spacer"></span>
  <app-button [disabled]="inProgress || !proceedAllowed()"
              (clicked)="proceed()"
              [label]="action"></app-button>
</div>
